import { MULTI_CURRENCY_TYPE } from '../../constant/index';

export const isSpecialMultiCurrency = (multiCurrencyInfo = {}) => {
  const { type, isOpened } = multiCurrencyInfo;
  return type === MULTI_CURRENCY_TYPE.special && isOpened === 1;
};
